export default __webpack_public_path__ + "4ea32930033d86565384a1f48c0a2951.svg";